import React from "react";

const SideNavigation = ({ sourceMap, activePath }) => {
    return (
        <ul className="side-navigation">
            {sourceMap.map(({ currentPath, label, path }, index) => {
                const isActive = activePath === path;

                return (
                    <li key={`nav-${index}`} className={`${isActive ? "-active" : ""}`}>
                        <a href={path}>{label}</a>
                    </li>
                );
            })}
        </ul>
    );
};

export default SideNavigation;
